export default __webpack_public_path__ + "media/images/temporary/contact-hero-d55ff62748276e8196250e63171bdedc.jpg";